import React from 'react';
import MedicalServicesRoundedIcon from '@mui/icons-material/MedicalServicesRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import ChildCareRoundedIcon from '@mui/icons-material/ChildCareRounded';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import PsychologyRoundedIcon from '@mui/icons-material/PsychologyRounded';
import HealingRoundedIcon from '@mui/icons-material/HealingRounded';
import BiotechRoundedIcon from '@mui/icons-material/BiotechRounded';
import MonitorHeartRoundedIcon from '@mui/icons-material/MonitorHeartRounded';
import SpaRoundedIcon from '@mui/icons-material/SpaRounded';
import HearingRoundedIcon from '@mui/icons-material/HearingRounded';
import AirRoundedIcon from '@mui/icons-material/AirRounded';
import AccessibilityNewRoundedIcon from '@mui/icons-material/AccessibilityNewRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import VaccinesRoundedIcon from '@mui/icons-material/VaccinesRounded';
import PregnantWomanRoundedIcon from '@mui/icons-material/PregnantWomanRounded';
import SvgIcon from '@mui/material/SvgIcon';

// SVG ИКОНКА ЗУБА (нет в MUI)
export const ToothIcon: React.FC<{ sx?: any }> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M12 2C9.8 2 8 2.5 7 3.5C5.5 5 5 7 5 9c0 2.5 1 5 1.5 7 .5 1.8 1 4 1.8 5.5.4.8.9 1.5 1.7 1.5s1.2-.8 1.5-2c.3-1.2.5-2.5 1-3.5.3-.5.8-1 1.5-1s1.2.5 1.5 1c.5 1 .7 2.3 1 3.5.3 1.2.7 2 1.5 2s1.3-.7 1.7-1.5C18 19 18.5 16.8 19 15c.5-2 1.5-4.5 1.5-7 0-2-.5-4-2-5.5C17.5 1.5 14.2 2 12 2z" />
  </SvgIcon>
);

// МАППИНГ КЛЮЧЕВЫХ СЛОВ → ИКОНКИ

const ICON_MAP: { keywords: string[]; icon: (sx: any) => React.ReactElement }[] = [
  { keywords: ['стоматолог', 'зуб', 'дентал', 'ортодонт', 'пародонт', 'отбеливан'], icon: (sx) => <ToothIcon sx={sx} /> },
  { keywords: ['кардиолог', 'сердц', 'кардио', 'давление'], icon: (sx) => <FavoriteRoundedIcon sx={sx} /> },
  { keywords: ['педиатр', 'детск', 'неонатолог', 'дети'], icon: (sx) => <ChildCareRoundedIcon sx={sx} /> },
  { keywords: ['офтальмолог', 'глаз', 'оптик', 'зрение'], icon: (sx) => <VisibilityRoundedIcon sx={sx} /> },
  { keywords: ['невролог', 'нейро', 'психиатр', 'психотерапевт', 'психолог', 'психо'], icon: (sx) => <PsychologyRoundedIcon sx={sx} /> },
  { keywords: ['хирург', 'операци'], icon: (sx) => <HealingRoundedIcon sx={sx} /> },
  { keywords: ['эндокринолог', 'гормон', 'диабет'], icon: (sx) => <BiotechRoundedIcon sx={sx} /> },
  { keywords: ['узи', 'диагност', 'рентген', 'мрт', 'кт', 'анализ'], icon: (sx) => <MonitorHeartRoundedIcon sx={sx} /> },
  { keywords: ['дерматолог', 'косметолог', 'кожн', 'красота'], icon: (sx) => <SpaRoundedIcon sx={sx} /> },
  { keywords: ['лор', 'отоларинголог', 'сурдолог', 'ухо'], icon: (sx) => <HearingRoundedIcon sx={sx} /> },
  { keywords: ['пульмонолог', 'лёгк', 'легк', 'дыхат'], icon: (sx) => <AirRoundedIcon sx={sx} /> },
  { keywords: ['ортопед', 'травматолог', 'реабилит', 'физиотерап'], icon: (sx) => <AccessibilityNewRoundedIcon sx={sx} /> },
  { keywords: ['онколог', 'опухол'], icon: (sx) => <HealthAndSafetyRoundedIcon sx={sx} /> },
  { keywords: ['гинеколог', 'акушер', 'женск'], icon: (sx) => <PregnantWomanRoundedIcon sx={sx} /> },
  { keywords: ['уролог', 'нефролог', 'почк'], icon: (sx) => <VaccinesRoundedIcon sx={sx} /> },
  { keywords: ['гастроэнтеролог', 'желудо', 'кишеч', 'пищевар'], icon: (sx) => <MedicalServicesRoundedIcon sx={sx} /> },
  { keywords: ['аллерголог', 'иммунолог'], icon: (sx) => <VaccinesRoundedIcon sx={sx} /> },
  { keywords: ['терапевт', 'терапи', 'врач общ', 'консультац'], icon: (sx) => <MedicalServicesRoundedIcon sx={sx} /> },
];

/**
 * Подбирает медицинскую иконку по названию (специализации или услуги)
 * @param name - название для подбора
 * @param size - размер иконки (по умолчанию 20)
 */
export function getMedicalIcon(name: string, size: number = 20): React.ReactElement {
  const lower = name.toLowerCase();
  const sx = { color: '#fff', fontSize: size };

  for (const entry of ICON_MAP) {
    if (entry.keywords.some(kw => lower.includes(kw))) return entry.icon(sx);
  }

  return <MedicalServicesRoundedIcon sx={sx} />;
}
